<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liyong
 * @LastEditTime: 2022-08-05 17:35:10
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 * 
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved. 
-->
<template>
	<div class="pre">{{ rulesText | formatEmpty }}</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import { PLATFORM_DY, PLATFORM_KS, PLATFORM_SP } from '@/utils/dataMap';
const texts = {
	[PLATFORM_DY.value]: {
		salesLabel: '月橱窗销量',
		salesAmountLabel: '月橱窗销售额',
	},
	[PLATFORM_KS.value]: {
		salesLabel: '月订单量',
		salesAmountLabel: '月销售额',
	},
	[PLATFORM_SP.value]: {
		salesLabel: '月订单量',
		salesAmountLabel: '月销售额',
	},
};
export default {
	mixins: [mixin],
	computed: {
		platformId() {
			return +this.row?.platform_id;
		},
		conf() {
			return {
				fans_num: '粉丝量',
				sales: texts[this.platformId].salesLabel,
				sale_amount: texts[this.platformId].salesAmountLabel,
			};
		},
		rulesText() {
			const { anchor_ids, outer_product_id, ...rest } = this.cellValue;
			const text = Object.keys(rest).reduce((all, cur) => `${all}${this.conf[cur]} ≥ ${this.unit1Format(rest[cur], cur === 'sale_amount')}\n`, '');
			return text;
		},
	},
	methods: {
		unit1Format(value, showRmb = false) {
			let val = Number(value);
			if (val >= 10 ** 4) return `${showRmb ? '¥' : ''}${Math.round((val / 10 ** 4) * 100) / 100}w`;
			else return `${showRmb ? '¥' : ''}${val}`;
		},
	},
};
</script>